import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { MANAGEMENT_PRINT_PAGE_STYLE } from "../utils/management-print.utils";

/**
 * Print / Save-as-PDF for a Management dashboard surface via `react-to-print`.
 */
export function useManagementPrint(documentTitle: string) {
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    content: () => contentRef.current,
    copyStyles: true,
    documentTitle,
    pageStyle: MANAGEMENT_PRINT_PAGE_STYLE
  });

  return { contentRef, handlePrint };
}
